// Pipeline stage labels + percentage ranges for resume upload/parse visual progress
export const PIPELINE_STAGES = {
  uploading: { label: 'Uploading', icon: '↑', pctRange: [0, 30] },
  uploaded:  { label: 'Queued', icon: '⏳', pctRange: [30, 40] },
  parsing:   { label: 'Parsing Resume', icon: '📄', pctRange: [40, 65] },
  matching:  { label: 'Matching to JD', icon: '🔍', pctRange: [65, 90] },
  completed: { label: 'Done', icon: '✓', pctRange: [100, 100] },
  error:     { label: 'Failed', icon: '✕', pctRange: [0, 0] },
};

export function getStageProgress(status, uploadPct = 0) {
  if (status === 'uploading') return Math.round(uploadPct * 0.3); // 0-30%
  const stage = PIPELINE_STAGES[status];
  if (!stage) return 0;
  return Math.round((stage.pctRange[0] + stage.pctRange[1]) / 2);
}

export function getStageColor(status) {
  if (status === 'completed') return '#10B981';
  if (status === 'error') return '#EF4444';
  return '#0076A3';
}
